// extracted by mini-css-extract-plugin
export default {"container":"modal-content-layout-module--container--06e22"};